import type { NodeSelection } from '@frontend/pages/dashboard/types';
import HotloadingControlGroup from './HotloadingControlGroup';
import type { HotStackUiPhase } from '@frontend/types/hotloading';

interface AccountSectionProps {
  userName: string;
  environmentLabel: string;
  showHotloadingControl: boolean;
  stackUiPhase: HotStackUiPhase;
  routeMode: 'hot' | 'parity';
  routeToggleEnabled: boolean;
  routeToHotAllowed: boolean;
  routeBusy: boolean;
  stackBusy: boolean;
  hotloadingError?: string;
  selected: NodeSelection;
  onSelectSettings: () => void;
  onHotStackToggle: () => void;
  onHotRouteToggle: () => void;
  onLogout: () => void;
}

export default function AccountSection({
  userName,
  environmentLabel,
  showHotloadingControl,
  stackUiPhase,
  routeMode,
  routeToggleEnabled,
  routeToHotAllowed,
  routeBusy,
  stackBusy,
  hotloadingError,
  selected,
  onSelectSettings,
  onHotStackToggle,
  onHotRouteToggle,
  onLogout
}: AccountSectionProps) {
  return (
    <div className="tree-dashboard-sidebar-section">
      <div className="tree-dashboard-sidebar-title">Account</div>
      <div className="sidebar-account-panel">
        <div className="sidebar-avatar-row">
          <div className="sidebar-avatar-badge">
            {userName.split(' ').map((w: string) => w[0]).slice(0, 2).join('').toUpperCase()}
          </div>
          <div className="sidebar-avatar-info">
            <div className="sidebar-account-name">{userName}</div>
            <div className="sidebar-account-meta-row">
              <span className="tree-dashboard-account-env">{environmentLabel}</span>
            </div>
            {showHotloadingControl ? (
              <HotloadingControlGroup
                stackPhase={stackUiPhase}
                routeMode={routeMode}
                routeToggleEnabled={routeToggleEnabled}
                routeToHotAllowed={routeToHotAllowed}
                routeBusy={routeBusy}
                stackBusy={stackBusy}
                error={hotloadingError}
                onStackToggle={onHotStackToggle}
                onRouteToggle={onHotRouteToggle}
              />
            ) : null}
          </div>
        </div>
        <div className="tree-dashboard-quick-links">
          <button
            type="button"
            className={`tree-dashboard-quick-link tree-dashboard-quick-link-button ${selected.kind === 'ecosystem-settings' ? 'active' : ''}`}
            onClick={onSelectSettings}
          >
            Ecosystem Settings
          </button>
          <button type="button" className="tree-dashboard-quick-link tree-dashboard-quick-link-button" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
